const STORAGE_KEY = "queues-settings";

export interface IQueuesSettings {
  /** seconds between automatic refreshes; 0 turns it off */
  refreshSeconds: number;
  /** jobs per page */
  pageSize: number;
}

export const REFRESH_OPTIONS = [0, 5, 10, 30, 60];
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const defaultQueuesSettings: IQueuesSettings = { refreshSeconds: 0, pageSize: 25 };

/** Settings are a per-browser convenience, so a blocked or corrupt store falls back to the defaults. */
export const loadQueuesSettings = (): IQueuesSettings => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

    return {
      refreshSeconds: REFRESH_OPTIONS.includes(stored.refreshSeconds)
        ? stored.refreshSeconds
        : defaultQueuesSettings.refreshSeconds,
      pageSize: PAGE_SIZE_OPTIONS.includes(stored.pageSize) ? stored.pageSize : defaultQueuesSettings.pageSize
    };
  } catch (e) {
    return defaultQueuesSettings;
  }
};

export const saveQueuesSettings = (settings: IQueuesSettings) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch (e) {
    // The setting still applies for this visit.
  }
};
